import jQuery from 'jquery';
import BaseFeature from '../../foundation/base/base';

export class RehabForm extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.settings = this.parseSettings();

		this.removeOptions();
	}

	parseSettings() {
		const settings = this.el.getAttribute('data-settings');
		return JSON.parse(settings);
	}

	// In step 1 we remove spcific option values if any of these are disabled in Sitecore
	removeOptions() {
		const $form = jQuery(this.el);
		const optionsToDelete = this.settings.options;

		if (optionsToDelete.length > 0) {
			$form.find('select > option').each((index, item) => {
				const $item = jQuery(item);
				if (jQuery.inArray($item.val(), optionsToDelete) !== -1) {
					$item.remove();
				}
			});
		}
	}
}

export default RehabForm;
